'use client';

import { cn } from '@commander/utils';
import * as ProgressPrimitive from '@radix-ui/react-progress';
import type * as React from 'react';

function Progress({
  className,
  progressBarClass,
  value,
  rounded = 'rounded-full',
  ...props
}: React.ComponentProps<typeof ProgressPrimitive.Root> & {
  progressBarClass?: string;
  rounded?: string;
}) {
  return (
    <ProgressPrimitive.Root
      data-slot="progress"
      className={cn('bg-primary/20 relative h-2 w-full overflow-hidden', rounded, className)}
      {...props}
    >
      <ProgressPrimitive.Indicator
        data-slot="progress-indicator"
        className={cn('bg-primary h-full w-full flex-1 transition-all', progressBarClass)}
        style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
      />
    </ProgressPrimitive.Root>
  );
}

export { Progress };
